import * as commissionMemberService from '@/services/apis/commissionMember'
const state = {}

const actions = {
  async getCommissionMemberHistoryReport({}, params) {
    try {
      let text = 'time_from='+params.time_from+'&time_to='+params.time_to+'&type='+params.type+'&page='+params.page+'&rows='+params.rows+'&phone='+params.search;

      const res = await commissionMemberService.getCommissionMemberHistoryReport(text)

      return res.data
    } catch (err) {
      if(err.message){ throw JSON.parse(err.message) }
    }
  },
  async getAllCommissionRole({}) {
    try {
      const res = await commissionMemberService.getAllCommissionRole()

      return res.data
    } catch (err) {
      if(err.message){ throw JSON.parse(err.message) }
    }
  },
  async getCommissionRoleById({},params) {
    try {
      const res = await commissionMemberService.getCommissionRoleById(params)

      return res.data
    } catch (err) {
      if(err.message){ throw JSON.parse(err.message) }
    }
  },

  async updateCommissionRoleById({},params) {
    try {
      const res = await commissionMemberService.updateCommissionRoleById(params)

      return res.data
    } catch (err) {
      if(err.message){ throw JSON.parse(err.message) }
    }
  },

  async addNewCommissionRole({},params) {
    try {
      const res = await commissionMemberService.addNewCommissionRole(params)

      return res.data
    } catch (err) {
      if(err.message){ throw JSON.parse(err.message) }
    }
  },
}

export default {
  state,
  actions,
}
